import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';

/**
 * Tracks page views for authenticated users.
 * Debounces to avoid duplicate entries on rapid navigation.
 */
export function usePageTracking() {
  const location = useLocation();
  const lastTracked = useRef('');

  useEffect(() => {
    const path = location.pathname;
    if (path === lastTracked.current) return;
    lastTracked.current = path;

    supabase.auth.getUser().then(({ data }) => {
      if (data.user) {
        // Legacy page_views table
        supabase.from('page_views').insert({
          user_id: data.user.id,
          path,
        }).then(() => {});

        // Also log to user_activity for unified timeline
        supabase.from('user_activity' as any).insert({
          user_id: data.user.id,
          action_type: 'page_view',
          label: path,
        } as any).then(() => {});
      }
    });
  }, [location.pathname]);
}
